import { getElementOffset } from './Utils';


export default class SmoothScroll
{


    constructor ()
    {
        this.smoothScrollLinks = document.querySelectorAll( 'a[href^="#"]:not(a[href^="#login"])' );

        this.maybeDoInitialScroll();

        if ( this.smoothScrollLinks.length > 0 )
        {
            this.bindSmoothScroll();
        }
    }


    bindSmoothScroll ()
    {
        Array.from( this.smoothScrollLinks )
            .forEach( ( el, i ) =>
            {
                el.addEventListener( 'click', this.scrollTo );
            } );
    }

    unbindSmoothScroll ()
    {
        Array.from( this.smoothScrollLinks )
            .forEach( ( el, i ) =>
            {
                el.removeEventListener( 'click', this.scrollTo );
            } );
    }

    resetSmoothScroll ()
    {
        this.unbindSmoothScroll();

        // update our array of links
        this.smoothScrollLinks = document.querySelectorAll( 'a[href^="#"] ' );

        this.bindSmoothScroll();
    }

    scrollTo ( event )
    {

        const clicked                  = event.target;
        const href                     = clicked.getAttribute( 'href' );
        const foundMatchingDestination = document.querySelector( href );
        const headerHeight = document.querySelector( '#site-header' ).getBoundingClientRect().height;

        if ( !foundMatchingDestination )
        {
            return true;
        }

        event.preventDefault();


        window.scrollTo( {
            top      : getElementOffset( foundMatchingDestination ).top - 20 - headerHeight,
            left     : 0,
            behavior : 'smooth',
        } );


    }


    maybeDoInitialScroll ()
    {
        const maybeHash = window.top.location.hash;
        const hasHash   = maybeHash.length > 0;

        if ( !hasHash )
        {
            return;
        }

        // const maybeDestination = document.querySelector( maybeHash + '_directement' );
        const maybeDestination = document.querySelector( maybeHash );

        if ( maybeDestination )
        {

            setTimeout( () =>
            {
                const isLexiconIndex = document.querySelector( 'body' ).classList.contains( 'lexicon-index' );
                const offset         = isLexiconIndex ? 130 : 50;
                const headerHeight = document.querySelector( '#site-header' ).getBoundingClientRect().height;


                window.scrollTo( {
                    top      : getElementOffset( maybeDestination ).top - offset - headerHeight,
                    left     : 0,
                    behavior : 'smooth',
                } );

                if ( isLexiconIndex )
                {
                    setTimeout( () =>
                    {
                        maybeDestination.classList.add( 'flash-me' );
                    }, 1000 );
                }


            }, 1000 );
        }
    }

}
